import { FeatureFlagName } from "../../mp-utils/generic-utils/feature-flags/types"
import { ContentType, DetailsDataParams, TableRowAction } from "../types"
import { ContentTypeLabels } from "./labels"

export const DETAILS_REQUEST_PARAMS = {
  "teaching-tools": {
    "test-administration_id": {
      dimensions: ["name"],
      measures: []
    }
  },
  organization: {
    states_id: {
      dimensions: [
        "org_view_states.code",
        "org_view_states.isActive",
        "org_view_states.activeStudentsCount"
      ],
      measures: [
        "org_view_states.districtCount",
        "org_view_states.schoolsCount"
      ]
    },
    districts_id: {
      dimensions: [
        "org_view_districts.districtId",
        "org_view_districts.districtName",
        "org_view_districts.state",
        "org_view_districts.activeStudentsCount",
        "org_view_districts.isActive",
        "org_view_districts.createdAt"
      ],
      measures: [
        "org_view_districts.schoolsCount",
        "org_view_districts.teachersCount",
        "org_view_districts.districtAdminsCount"
      ]
    },
    schools_id: {
      dimensions: [
        "org_view_schools.id",
        "org_view_schools.name",
        "org_view_schools.districtId",
        "org_view_schools.districtName",
        "org_view_schools.createdAt",
        "org_view_schools.activeStudentsCount",
        "org_view_schools.isActive"
      ],
      measures: [
        "org_view_schools.studentsCount",
        "org_view_schools.teachersCount",
        "org_view_schools.adminsCount"
      ]
    },
    teachers_id: {
      dimensions: [
        "org_view_teachers.id",
        "org_view_teachers.fullName",
        "org_view_teachers.firstName",
        "org_view_teachers.lastName",
        "org_view_teachers.title",
        "org_view_teachers.schoolId",
        "org_view_teachers.additionalSchoolIds",
        "org_view_teachers.districtId",
        "org_view_teachers.schoolName",
        "org_view_teachers.email",
        "org_view_teachers.userName",
        "org_view_teachers.teacherLastActive",
        "org_view_teachers.teacherIsActive",
        "org_view_teachers.createdAt"
      ],
      measures: [
        "org_view_teachers.classesCount",
        "org_view_teachers.activeStudentsCount",
        "org_view_teachers.studentsCount"
      ]
    },
    classes_id: {
      dimensions: [
        "org_view_classes.id",
        "org_view_classes.name",
        "org_view_classes.period",
        "org_view_classes.districtId",
        "org_view_classes.schoolId",
        "org_view_classes.schoolName",
        "org_view_classes.teacherId",
        "org_view_classes.teacherName",
        "org_view_classes.grades",
        "org_view_classes.courseCode",
        "org_view_classes.subject"
      ],
      measures: ["org_view_classes.isActive"]
    },
    admins_id: {
      dimensions: [
        "org_view_admins.id",
        "org_view_admins.fullName",
        "org_view_admins.firstName",
        "org_view_admins.lastName",
        "org_view_admins.title",
        "org_view_admins.sfid",
        "org_view_admins.email",
        "org_view_admins.userName",
        "org_view_admins.role",
        "org_view_admins.isTeacher",
        "org_view_admins.schoolId",
        "org_view_admins.schoolName",
        "org_view_admins.districtId",
        "org_view_admins.districtName",
        "org_view_admins.state",
        "org_view_admins.createdAt"
      ],
      measures: ["org_view_admins.isActive", "org_view_admins.lastActive"]
    },
    students_id: {
      dimensions: [
        "org_view_students.studentId",
        "org_view_students.studentFullname",
        "org_view_students.studentFirstName",
        "org_view_students.studentLastName",
        "org_view_students.schoolId",
        "org_view_students.schoolName",
        "org_view_students.grade",
        "org_view_students.email",
        "org_view_students.studentUserName",
        "org_view_students.createdAt",
        "org_view_students.districtId",
        "org_view_students.isActive",
        "org_view_students.externalStudentId"
      ]
    }
  },
  content: {
    "content-library/element_id": {
      dimensions: [
        "content_view_br_lessons.id",
        "content_view_br_lessons.name",
        "content_view_br_lessons.description",
        "content_view_br_lessons.program",
        "content_view_br_lessons.subject",
        "content_view_br_lessons.duration",
        "content_view_br_lessons.standards",
        "content_view_br_lessons.nodeNames",
        "content_view_br_lessons.exersisesCount"
      ]
    },
    "content-library/study-hall_id": {
      dimensions: [
        "content_view_sh_lessons.id",
        "content_view_sh_lessons.name",
        "content_view_sh_lessons.description",
        "content_view_sh_lessons.program",
        "content_view_sh_lessons.subject",
        "content_view_sh_lessons.duration",
        "content_view_sh_lessons.standards",
        "content_view_sh_lessons.nodeNames",
        "content_view_sh_lessons.questionsCount"
      ]
    },
    "content-library/practice-test_id": {
      dimensions: [
        "content_view_tests.id",
        "content_view_tests.name",
        "content_view_tests.program",
        "content_view_tests.nodeNames"
      ],
      measures: ["content_view_tests.itemsCount"]
    },
    "content-library/mastery-lesson_id": {
      dimensions: [
        "content_view_ml_lessons.id",
        "content_view_ml_lessons.name",
        "content_view_ml_lessons.description",
        "content_view_ml_lessons.program",
        "content_view_ml_lessons.subject",
        "content_view_ml_lessons.duration",
        "content_view_ml_lessons.nodeNames",
        "content_view_ml_lessons.standards",
        "content_view_ml_lessons.interactionsCount",
        "content_view_ml_lessons.questionCount"
      ]
    },
    "content-library/mastery-curriculum_id": {
      dimensions: [
        "content_view_mc_lessons.id",
        "content_view_mc_lessons.name",
        "content_view_mc_lessons.description",
        "content_view_mc_lessons.program",
        "content_view_mc_lessons.subject",
        "content_view_mc_lessons.duration",
        "content_view_mc_lessons.nodeNames",
        "content_view_mc_lessons.questionsCount"
      ]
    }
  }
}

export const DETAILS_BY_VIEW: Record<
  string,
  Record<string, DetailsDataParams>
> = {
  "teaching-tools": {
    assignments_id: {
      title: "assignmentName",
      entity: "Assignment",
      editable: false
    },
    "test-administration_id": {
      title: "name",
      entity: "Test Administration",
      editable: true
    }
  },
  organization: {
    states_id: {
      title: "org_view_states.code",
      entity: "State",
      isActive: "org_view_states.isActive",
      editable: false,
      counts: {
        Districts: "org_view_states.districtCount",
        Schools: "org_view_states.schoolsCount",
        ActiveStudents: "org_view_states.activeStudentsCount"
      },
      tables: [
        {
          label: "Districts",
          entity: "districts",
          entityLabel: "District",
          icon: "city",
          requestParam: "org_view_districts.state"
        }
      ]
    },
    districts_id: {
      title: "org_view_districts.districtName",
      subtitlesData: [
        {
          subtitle: "org_view_districts.state",
          subtitleEntity: "states",
          subtitleLink: "org_view_districts.state"
        }
      ],
      entity: "District",
      isActive: "org_view_districts.isActive",
      editable: true,
      counts: {
        Schools: "org_view_districts.schoolsCount",
        Teachers: "org_view_districts.teachersCount",
        ActiveStudents: "org_view_districts.activeStudentsCount",
        DistrictAdmins: "org_view_districts.districtAdminsCount"
      },
      details: [
        {
          label: "Created",
          value: "org_view_districts.createdAt",
          format: "date"
        }
      ],
      tables: [
        {
          label: "Schools",
          icon: "school",
          entity: "schools",
          requestParam: "org_view_schools.districtId"
        }
        // {
        //   label: "License Pools",
        //   icon: "key-skeleton-left-right",
        //   entity: "license-pools",
        //   requestParam: "org_view_licenses.districtId"
        // }
      ]
    },
    schools_id: {
      title: "org_view_schools.name",
      subtitlesData: [
        {
          subtitle: "org_view_schools.districtName",
          subtitleEntity: "districts",
          subtitleLink: "org_view_schools.districtId"
        }
      ],
      entity: "School",
      isActive: "org_view_schools.isActive",
      editable: true,
      counts: {
        Teachers: "org_view_schools.teachersCount",
        Students: "org_view_schools.studentsCount",
        ActiveStudents: "org_view_schools.activeStudentsCount",
        SchoolAdmins: "org_view_schools.adminsCount"
      },
      details: [
        {
          label: "Created",
          value: "org_view_schools.createdAt",
          format: "date"
        }
      ],
      tables: [
        {
          label: "Teachers",
          icon: "chalkboard-teacher",
          entity: "teachers",
          requestParam: "org_view_teachers.schoolId"
        },
        {
          label: "Classes",
          icon: "users-class",
          entity: "classes",
          requestParam: "org_view_classes.schoolId"
        },
        {
          label: "Students",
          icon: "user",
          entity: "students",
          requestParam: "org_view_students.schoolId"
        }
      ]
    },
    teachers_id: {
      title: "org_view_teachers.fullName",
      subtitlesData: [
        {
          subtitle: "org_view_teachers.schoolName",
          subtitleEntity: "schools",
          subtitleLink: "org_view_teachers.schoolId"
        }
      ],
      entity: "Teacher",
      isActive: "org_view_teachers.teacherIsActive",
      editable: true,
      details: [
        {
          label: "Email",
          value: "org_view_teachers.email",
          format: "email"
        },
        {
          label: "Created",
          value: "org_view_teachers.createdAt",
          format: "date"
        },
        {
          label: "Last Login",
          value: "org_view_teachers.teacherLastActive",
          format: "date"
        }
      ],
      counts: {
        Classes: "org_view_teachers.classesCount",
        Students: "org_view_teachers.studentsCount",
        ActiveStudents: "org_view_teachers.activeStudentsCount"
      },
      tables: [
        {
          label: "Classes",
          icon: "users-class",
          entity: "classes",
          requestParam: "org_view_classes.teacherId"
        },
        {
          label: "Students",
          icon: "user",
          entity: "students",
          requestParam: "org_view_students.teacherId"
        },
        {
          label: "Activity Log",
          icon: "arrow-pointer",
          page: "insights",
          entity: "details-usage",
          requestParam: "usage_activity_logs.userId"
        }
      ]
    },
    classes_id: {
      title: "org_view_classes.name",
      subtitlesData: [
        {
          subtitle: "org_view_classes.schoolName",
          subtitleEntity: "schools",
          subtitleLink: "org_view_classes.schoolId"
        }
      ],
      entity: "Class",
      isActive: "org_view_classes.isActive",
      editable: true,
      counts: {},
      tables: [
        {
          label: "Students",
          icon: "user",
          entity: "students",
          requestParam: "org_view_students.classId"
        }
      ]
    },
    students_id: {
      title: "org_view_students.studentFullname",
      subtitlesData: [
        {
          subtitle: "org_view_students.schoolName",
          subtitleEntity: "schools",
          subtitleLink: "org_view_students.schoolId"
        }
      ],
      entity: "Student",
      isActive: "org_view_students.isActive",
      editable: true,
      impersonatable: true,
      details: [
        // externalStudentId is an external id being added by users
        {
          label: "Student ID",
          value: "org_view_students.externalStudentId"
        },
        {
          label: "Created",
          value: "org_view_students.createdAt",
          format: "date"
        },
        {
          label: "Grade",
          value: "org_view_students.grade",
          format: "grade"
        },
        // ! This is not yet working so commented out for now but will need to go here
        // {
        //   label: "Timing Accommodations",
        //   value: "org_view_students.timingAccommodations"
        // },
        {
          label: "Email",
          value: "org_view_students.email",
          format: "email"
        }
      ],
      tables: [
        {
          label: "Classes",
          icon: "users-class",
          entity: "classes",
          requestParam: "org_view_classes.studentId"
        },
        {
          label: "Activity Log",
          icon: "arrow-pointer",
          page: "insights",
          entity: "details-usage",
          requestParam: "usage_activity_logs.userId"
        },
        {
          label: "Access",
          icon: "key-skeleton-left-right",
          entity: "student-accesses"
        },
        {
          label: "Performance Report",
          icon: "bars-progress",
          page: "insights",
          entity: "performance-report",
          requestParam: "performance_report.id",
          featureFlag:
            FeatureFlagName.reporting_organization_student_performance_report
        }
      ]
    },
    admins_id: {
      title: "org_view_admins.fullName",
      entity: "Admin",
      isActive: "org_view_admins.isActive",
      editable: true,
      counts: {},
      details: [
        {
          label: "Email",
          value: "org_view_admins.email",
          format: "email"
        },
        {
          label: "Created",
          value: "org_view_admins.createdAt",
          format: "date"
        },
        {
          label: "Last Active",
          value: "org_view_admins.lastActive",
          format: "dateTime"
        }
      ]
    }
  },
  content: {
    "content-library/element_id": {
      id: "content_view_br_lessons.id",
      title: "content_view_br_lessons.name",
      description: "content_view_br_lessons.description",
      subtitlesData: [
        {
          subtitle: [
            "content_view_br_lessons.program",
            "content_view_br_lessons.subject"
          ],
          subtitleEntity: "test"
        }
      ],
      entity: ContentTypeLabels[ContentType.bellRinger],
      editable: false,
      counts: {
        ApproxDuration: "content_view_br_lessons.duration",
        QuestionsCount: "content_view_br_lessons.exersisesCount"
      },
      details: [
        {
          label: "Standards",
          value: "content_view_br_lessons.standards",
          format: "array"
        },
        {
          label: "Reporting Categories",
          value: "content_view_br_lessons.nodeNames"
        }
      ],
      detailsColumns: 1
      // actions: [TableRowAction.preview]
    },
    "content-library/study-hall_id": {
      id: "content_view_sh_lessons.id",
      title: "content_view_sh_lessons.name",
      description: "content_view_sh_lessons.description",
      subtitlesData: [
        {
          subtitle: [
            "content_view_sh_lessons.program",
            "content_view_sh_lessons.subject"
          ],
          subtitleEntity: "test"
        }
      ],
      entity: ContentTypeLabels[ContentType.skillReview],
      editable: false,
      counts: {
        ApproxDuration: "content_view_sh_lessons.duration",
        PracticeQuestionsCount: "content_view_sh_lessons.questionsCount"
      },
      details: [
        {
          label: "Standards",
          value: "content_view_sh_lessons.standards",
          format: "array"
        },
        {
          label: "Reporting Categories",
          value: "content_view_sh_lessons.nodeNames"
        }
      ],
      detailsColumns: 1
      // actions: [TableRowAction.preview]
    },
    "content-library/practice-test_id": {
      id: "content_view_tests.id",
      title: "content_view_tests.name",
      subtitlesData: [
        {
          subtitle: "content_view_tests.program",
          subtitleEntity: "test"
        }
      ],
      entity: ContentTypeLabels[ContentType.practiceTest],
      editable: false,
      counts: {},
      details: [
        {
          label: "Reporting Categories",
          value: "content_view_tests.nodeNames"
        }
      ],
      detailsColumns: 1,
      actions: [TableRowAction.preview]
    },
    "content-library/mastery-lesson_id": {
      id: "content_view_ml_lessons.id",
      title: "content_view_ml_lessons.name",
      description: "content_view_ml_lessons.description",
      subtitlesData: [
        {
          subtitle: [
            "content_view_ml_lessons.program",
            "content_view_ml_lessons.subject"
          ],
          subtitleEntity: "test"
        }
      ],
      entity: ContentTypeLabels[ContentType.masteryLesson],
      editable: false,
      counts: {
        ApproxDuration: "content_view_ml_lessons.duration",
        InteractionsCount: "content_view_ml_lessons.interactionsCount",
        PracticeQuestionsCount: "content_view_ml_lessons.questionCount"
      },
      details: [
        {
          label: "Standards",
          value: "content_view_ml_lessons.standards",
          format: "array"
        },
        {
          label: "Reporting Categories",
          value: "content_view_ml_lessons.nodeNames"
        }
      ],
      detailsColumns: 1,
      actions: [TableRowAction.assignContent, TableRowAction.preview]
    },
    "content-library/mastery-curriculum_id": {
      id: "content_view_mc_lessons.id",
      title: "content_view_mc_lessons.name",
      description: "content_view_mc_lessons.description",
      subtitlesData: [
        {
          subtitle: [
            "content_view_mc_lessons.program",
            "content_view_mc_lessons.subject"
          ],
          subtitleEntity: "test"
        }
      ],
      entity: ContentTypeLabels[ContentType.masteryCurriculum],
      editable: false,
      counts: {
        ApproxDuration: "content_view_mc_lessons.duration",
        QuestionsCount: "content_view_mc_lessons.questionsCount"
      },
      details: [
        // {
        //   label: "Standards",
        //   value: "content_view_mc_lessons.standards",
        //   format: "array"
        // },
        {
          label: "Reporting Categories",
          value: "content_view_mc_lessons.nodeNames"
        }
      ],
      detailsColumns: 1
      // actions: [TableRowAction.preview]
    }
  }
}

export const CATEGORIES_REQUEST_PARAMS = {
  dimensions: ["reportingCategories.id", "reportingCategories.name"],
  filters: [
    {
      member: "reportingCategories.id",
      operator: "equals",
      values: []
    }
  ]
}
